export default __webpack_public_path__ + "static/media/portis.73b0b147.png";